import { z } from "zod";
export const TemplateMetaSchema = z.object({
    industry: z.string().min(1),
    trade: z.string().min(1),
    archetype: z.string().min(1),
    version: z.number().int().positive(),
    name: z.string().min(1),
    description: z.string().min(1),
});
